/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  changeQueryParams,
  changeStaticQueryParams,
  sendRequest,
  selectItemsIds,
  selectRequestState,
  selectPagination
} from 'mt-react-common/common/reducers/list/reducer';
import { t } from 'utils/translates';

import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PaginationBlock from '../../../Common/Pagination/PaginationBlock/index';

import MediumPreLoader from '../../../Common/PreLoaders/MediumPreLoader';
import TaskExecTaskOwnerItem from '../_items/TaskExecTaskOwnerItem';

class ExecutionsMyTasksList extends Component {
  componentWillMount() {
    this.props.changeStaticQueryParams({
      ...this.props.queryParamsStatic
    });
    this.props.sendRequest();
  }
  render() {
    let comments = null;
    if (this.props.requestState.inProgress) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            // eslint-disable-next-line react/no-array-index-key
            <TaskExecTaskOwnerItem
              key={`taskExecLightItem${itemId}`}
              exec={this.props.selectItemById(itemId)}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('Выполнения не найдены')} :-(</p>
        </div>
      );
    }

    return <React.Fragment>{comments}</React.Fragment>;
  }
}

ExecutionsMyTasksList.defaultProps = {
  queryParamsStatic: {}
};

ExecutionsMyTasksList.propTypes = {
  listReduceName: PropTypes.string.isRequired,
  queryParamsStatic: PropTypes.shape({}).isRequired,
  // CONNECT
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  initState: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  changeStaticQueryParams: PropTypes.func.isRequired,
  selectDynamicQueryParams: PropTypes.shape({}).isRequired,
  selectVisibleQueryParams: PropTypes.shape({}).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};

ExecutionsMyTasksList.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id =>
    selectItemById(state, 'tasksModule.collections.tasksExecsCollection', id),
  authUserId: selectUserId(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  changeStaticQueryParams: queryParams =>
    dispatch(changeStaticQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName, props.taskId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExecutionsMyTasksList)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/ExecutionsMyTasksList/ExecutionsMyTasksList.js